function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFAF20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.24 18H1.108C.496 18 0 18.504 0 19.125v33.75C0 53.496.496 54 1.109 54h42.13c.612 0 1.109-.504 1.109-1.125v-33.75c0-.621-.497-1.125-1.109-1.125zm-1.11 2.25v31.5H2.217v-31.5H42.13zM22.174 0c5.963 0 10.825 4.775 11.077 10.762l.01.488v3.375c0 .621-.497 1.125-1.109 1.125-.544 0-.997-.398-1.09-.923l-.019-.202V11.25c0-4.97-3.97-9-8.87-9-4.749 0-8.627 3.79-8.858 8.55l-.01.45v3.375c0 .621-.497 1.125-1.11 1.125-.544 0-.996-.398-1.09-.923l-.018-.202V11.25C11.087 5.037 16.051 0 22.174 0zM43.646 1.1l-7.843 7.957a1.133 1.133 0 0 0-.325.795v4.773c0 .62.497 1.125 1.11 1.125h4.707a1.1 1.1 0 0 0 .784-.33l7.838-7.951a1.137 1.137 0 0 0 0-1.591L45.215 1.1a1.097 1.097 0 0 0-1.568 0zm.782 2.388l3.137 3.183-6.73 6.827h-3.14v-3.182l6.733-6.829z"
}));

var SvgPurchasesTransactionsIcon = function SvgPurchasesTransactionsIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 54,
    style: {
      background: "transparent"
    },
    viewBox: "0 0 51 54",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPurchasesTransactionsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/purchases_transactions_icon.0a89249f.svg";
export { ForwardRef as ReactComponent };